$(document).ready(function(){
  	
   
  if($(window).width() > 1025){
   $(".reviews_container .reviews_holder").flickity({
        cellAlign: 'center',
        contain: true,
        autoPlay: false,
        pageDots: false,
        loop: true,
        wrapAround: true,
        pauseAutoPlayOnHover: false,
        prevNextButtons: true
    }); 
  } 
  else if($(window).width() > 749 && $(window).width() < 1025){
    $(".reviews_container .reviews_holder").flickity({
        cellAlign: 'left',
        contain: true,
        autoPlay: false,
        pageDots: true,
        loop: true,
        wrapAround: true,
        pauseAutoPlayOnHover: false,
        prevNextButtons: true
    });
  }
  else if($(window).width() < 750){
    $(".reviews_container .reviews_holder").flickity({
        cellAlign: 'left',
        contain: true,
        autoPlay: false,
        pageDots: false,
        loop: true,
        wrapAround: true,
        pauseAutoPlayOnHover: false,
        prevNextButtons: false
    });
  }
  
  if($(window).width() < 750){
    $(".text_image_block:not(.text_blocks_icon) .text_block_inner .text_block_slide").flickity({
        cellAlign: 'left',
        contain: true,
        autoPlay: false,
        pageDots: true,
        loop: true,
        wrapAround: true,
        pauseAutoPlayOnHover: false,
        prevNextButtons: false
    });
  }
  if($(window).width() < 1025){
    $(".footer .footer__content-top .logo--wrapper").append($(".footer .footer__content-top .footer-block--newsletter"));
  }
  
  $(window).resize(function(){
  	if($(window).width() < 1025){
      if($(".footer .footer__content-top .logo--wrapper .footer-block--newsletter").length == 0){
        $(".footer .footer__content-top .logo--wrapper").append($(".footer .footer__content-top .footer-block--newsletter"));
      }
    }
    else{
      if($(".footer .footer__content-top .logo--wrapper .footer-block--newsletter").length > 0 ){
    	$("footer .footer__content-top").append($(".footer .footer__content-top .logo--wrapper .footer-block--newsletter"));
      }
    }
  });
  
  
  
  
  $(".inner_menu_content_holder .header__icon .close_new").on("click", function(){
    $(".header .header__icon--menu").click()
  });
  
  $(".menu-drawer summary.menu-drawer__menu-item").on("click", function(){
  	if($(this).siblings(".menu-drawer__inner-submenu").find("ul.menu-drawer__menu").hasClass("active_menu")){
      $(this).siblings(".menu-drawer__inner-submenu").find("ul.menu-drawer__menu").removeClass("active_menu");
      $(this).siblings(".menu-drawer__inner-submenu").find("ul.menu-drawer__menu").slideUp();
      $(this).find(".icon-caret").css("transform","rotate(0deg)");
    }
    else{
      $(".menu-drawer .menu-drawer__inner-submenu ul.menu-drawer__menu").removeClass("active_menu");
      $(".menu-drawer .menu-drawer__inner-submenu ul.menu-drawer__menu").slideUp();
      $(".menu-drawer summary.menu-drawer__menu-item .icon-caret").css("transform","rotate(0deg)");
      $(this).siblings(".menu-drawer__inner-submenu").find("ul.menu-drawer__menu").addClass("active_menu");
      $(this).siblings(".menu-drawer__inner-submenu").find("ul.menu-drawer__menu").slideDown();
      $(this).find(".icon-caret").css("transform","rotate(180deg)");
    }
  });
  
//   $(".header--hover").mouseover(function(){
//   });
  
  
  $("custom-dropdown").on("click",function(){
    if($(this).hasClass("active")){
      $(this).removeClass("active")
       $(this).find(".dropdown-content2").slideUp()
    }
    else{
      $(this).find(".dropdown-content2").slideDown()
      $(this).addClass("active")
    }
  });
  
  $("custom-dropdown .dropdown-content2 a").on("click",function(){
    $(this).closest(".product-faqs").find(".faqs-opener").hide()
    $(this).closest(".product-faqs").find(".faqs-wrapper").hide()
    var data = $(this).attr("data-id");
    $(this).closest(".product-faqs").find(".faqs-opener[data-id='"+data+"']").show()
    $(this).closest(".product-faqs").find(".faqs-wrapper.faqs-type-"+data+"").show()
  });
  
  $(".quick-guide-content #sticky-sidebar .btn").on("click",function(){
    $(".quick-guide-content #sticky-sidebar .btn").removeClass("active");
    $(this).addClass("active");
    var handle = "faqs-type-"+$(this).attr("data-handle")+"";
    $(".quick-guide-content .product-faqs .faqs-wrapper").removeClass("show-mobile-first")
    $(".quick-guide-content .product-faqs .faqs-wrapper."+handle+"").addClass("show-mobile-first")
  });
  
  
  $(".product #large-image .product__media").on("click",function(){
  	 $(".product .product__media-wrapper slider-component .product__media-list").flickity('select', $(this).index()); 
  })
  
  $(".product .product__media-wrapper slider-component .product__media-list").on( 'change.flickity', function( event, index ) {
    $(".product #large-image .product__media.active-thumb").removeClass("active-thumb")
    $($(".product #large-image .product__media")[index]).addClass("active-thumb")
  });
  
  $(".col_filters_holder .facets__summary").on("click",function(){
    if($(window).width() > 749){
      if($(this).hasClass("activated")){
        $(this).removeClass("activated");
        $(this).next().slideUp();
      }
      else{
        $(this).addClass("activated");
        $(this).next().slideDown();
      }
    }
    else{
    	$(this).addClass("activated");
        $(this).next().slideDown();
    }
  });
  
  $(".custom_collection_listing .facet-checkbox input").on("change", function(){
       //     window.history.replaceState(null, null, "?"+$(this).val()+"=true");
    if($(".custom_collection_listing .facet-checkbox input:checked").length > 0){
      $(".main_coll_container .main__collections_holder").addClass("hide");
      $(".custom_collection_listing .facet-checkbox input:checked").each(function(){
       //           if($(this).val() != "all_collections"){
       //             $(".custom_collection_listing .first--collection input").prop("checked", false)
       //           }
         $(".main_coll_container .main__collections_holder[data-handle='"+$(this).val()+"']").removeClass("hide");
      });
    }
    else{
    	 $(".main_coll_container .main__collections_holder").removeClass("hide");
    }
  });
  
  
  $(".s-hero-images .add_hero_slider").on( 'change.flickity', function( event, index ) {
  	console.log($(this).find(".s-hero-image.is-selected"))
    var prod = $(this).find(".s-hero-image.is-selected img");
    $(this).closest(".hero_image_slider").find(".hero_slider_top_holder .shop--btn").html($(prod).attr("data-btn"));
    $(this).closest(".hero_image_slider").find(".hero_slider_top_holder .shop--btn").attr("href", $(prod).attr("data-btn-url"));
  });
  
//   CART JS
//     $("#cart-notification").addClass("animate");
//     function cartDrawer(){
//       $.ajax({
//               type: 'GET',
//               url: '/cart.js',
//               dataType: 'json', 
//               success: function (cart) {
//                  for(var i =0; i < cart.items.length; i++){
//                    var obj = "";
//                    console.log(cart.items[i].handle)
//                    if(cart.items[i].variant_options[0] != "Default Title"){
//                      obj += "<dl>";
//                      for(j = 0; j < cart.items[i].options_with_values.length; j++){
//                           obj +=   '<div class="cart-notification-product__option h4"> <dt>'+cart.items[i].options_with_values[j].name+': </dt> <dd>'+cart.items[i].options_with_values[j].value+'</dd> </div>'
//                      }
//                     obj += "</dl>";
//                    }
//                    var prod_image = cart.items[i].image.replace(".jpg","_140x.jpg");
//                    prod_image = prod_image.replace(".png","_140x.png");
//                    var counter = i+1;
//                    $('<quantity-dropdown data-variant="'+cart.items[i].variant_id+'" data-line='+i+' class="drop-down cart_quantity_new "> <div class="selected"> <a href="javascript:;"><span class="p3_text">'+cart.items[i].quantity+'</span></a> </div> <div class="options"> <ul> </ul> </div> </quantity-dropdown>')
//                    var listing_new = '';
//                    for(var j = 1; j <= 20 ; j++){
//                    	listing_new +=  ' <li><a class="p3_text" href="javascript:;" data-value="'+j+'">'+j+'</a></li>'
//                    }
//                    var listing = '<quantity-dropdown data-variant="'+cart.items[i].variant_id+'" data-line='+parseInt(counter)+' class="drop-down cart_quantity_new "> <div class="selected"> <a href="javascript:;"><span class="p3_text">'+cart.items[i].quantity+'</span></a> </div> <div class="options"> <ul> '+listing_new+' </ul> </div> </quantity-dropdown>';
//                    if(i == 0 ){
//                      $('.cart-notification-custom  #cart-notification-product').html('<div id="cart-notification-products '+cart.items[i].id+'" data-prod-name="prod-'+cart.items[i].handle+'" class="cart-notification-product"> <img class="cart-notification-product__image" src="'+prod_image+'" width="70" loading="lazy" > <div class="cart-notification-product__info"> <h3 class="cart-notification-product__name h4 p1_text bold" data-url="'+cart.items[i].url+'">'+cart.items[i].product_title +'</h3> '+obj+' <div class="cart_bottom_holder"> <div class="qty_heading_holder">  <h3 class="p1_text bold"> $'+(cart.items[i].original_line_price/100).toFixed(2)+' </h3>'+listing+' </div> <a class="remove_cart_drawer" data-line="'+cart.items[i].variant_id+'" href="javascript:;" class="cart-notification-remove p2_text" data-id="'+cart.items[i].variant_id+'">  remove </a> </div> </div> </div>');
//                    }
//                    else{
//                      $('.cart-notification-custom  #cart-notification-product').append('<div id="cart-notification-products '+cart.items[i].id+'" data-prod-name="prod-'+cart.items[i].handle+'" class="cart-notification-product"> <img class="cart-notification-product__image" src="'+prod_image+'" width="70" loading="lazy" > <div class="cart-notification-product__info"> <h3 class="cart-notification-product__name h4 p1_text bold" data-url="'+cart.items[i].url+'">'+cart.items[i].product_title +'</h3> '+obj+' <div class="cart_bottom_holder"><div class="qty_heading_holder"> <h3 class="p1_text bold"> $'+(cart.items[i].original_line_price/100).toFixed(2)+' </h3>'+listing+' </div> <a class="remove_cart_drawer" data-line="'+cart.items[i].variant_id+'" href="javascript:;" class="cart-notification-remove p2_text" data-id="'+cart.items[i].variant_id+'">  remove </a> </div> </div> </div>');
//                    }
                   
                   
//                  }
//                 $(".cart-notification-custom  .cart-notification-product[data-prod-name='prod-e5']").parent().prepend($(".cart-notification-custom  .cart-notification-product[data-prod-name='prod-e5']"))
//                     $("div#cart-notification-product").css("flex-direction","column");
//                     $(".cart-notification-custom #cart-notification__links").html("VIEW CART")
//                     $(".cart-notification-custom #cart-notification-button").html("VIEW CART")
//                     $(".header__icons  .cart-count-bubble span").html(cart.item_count)
//                     if(cart.items.length == 0){
//                       $(".cart-notification-custom .cart-notification__header .cart-notification__heading").css("display","none")
//                       $(".cart-notification-custom .cart-notification__header .cart-notification__heading.empty_cart_head").css("display","block")
//                       $("#cart-notification-product").html("");
//                       $(".cart-notification-custom").addClass("empty_cart_custom");
//                        $(".header .cart-count-bubble").css("display" ,"none");
//                     }
//                     else{
//                       $(".cart-notification-custom .cart-notification__header .cart-notification__heading").css("display","flex")
//                       $(".cart-notification-custom .cart-notification__header .cart-notification__heading.empty_cart_head").css("display","none")
//                       $(".cart-notification-custom").removeClass("empty_cart_custom");
//                        $(".header .cart-count-bubble").css("display" ,"block");
//                     }
//                     $(".cart_subtotal_holder span.subtotal_price").html('$'+(cart.original_total_price/100).toFixed(2)+'');
//                     $("#cart-notification").addClass("active");
//                    $("body").addClass("cart_drawer_open");
//               } 

//        });
//     }
//     function cartDrawer2(){
//       $.ajax({
//               type: 'GET',
//               url: '/cart.js',
//               dataType: 'json', 
//               success: function (cart) {
//                  for(var i =0; i < cart.items.length; i++){
//                    var obj = "";
//                    var objdesc = "";
//                     console.log(cart.items[i].url)
//                    if(cart.items[i].variant_options[0] != "Default Title"){
                     
//                      obj += "<dl>";
//                      for(j = 0; j < cart.items[i].options_with_values.length; j++){
//                           obj +=   '<div class="cart-notification-product__option h4"> <dt>'+cart.items[i].options_with_values[j].name+': </dt> <dd>'+cart.items[i].options_with_values[j].value+'</dd> </div>'
//                      }
//                     obj += "</dl>";
//                    }
//                    var prod_image = cart.items[i].image.replace(".jpg","_140x.jpg")
//                    prod_image = prod_image.replace(".png","_140x.png")
//                     var counter = i+1;
//                    $('<quantity-dropdown data-variant="'+cart.items[i].variant_id+'" data-line='+i+' class="drop-down cart_quantity_new "> <div class="selected"> <a href="javascript:;"><span class="p3_text">'+cart.items[i].quantity+'</span></a> </div> <div class="options"> <ul> </ul> </div> </quantity-dropdown>')
//                    var listing_new = '';
//                    for(var j = 1; j <= 20 ; j++){
//                    	listing_new +=  ' <li><a class="p3_text" href="javascript:;" data-value="'+j+'">'+j+'</a></li>'
//                    }
//                    var listing = '<quantity-dropdown data-variant="'+cart.items[i].variant_id+'" data-line='+parseInt(counter)+' class="drop-down cart_quantity_new "> <div class="selected"> <a href="javascript:;"><span class="p3_text">'+cart.items[i].quantity+'</span></a> </div> <div class="options"> <ul> '+listing_new+' </ul> </div> </quantity-dropdown>';
//                    if(i == 0 ){
//                      $('.cart-notification-custom  #cart-notification-product').html('<div id="cart-notification-products '+cart.items[i].id+'" data-prod-name="prod-'+cart.items[i].handle+'" class="cart-notification-product"> <img class="cart-notification-product__image" src="'+prod_image+'" width="70" loading="lazy" > <div class="cart-notification-product__info"> <h3 class="cart-notification-product__name h4 p1_text bold" data-url="'+cart.items[i].url+'">'+cart.items[i].product_title +'</h3> '+obj+' <div class="cart_bottom_holder"> <div class="qty_heading_holder">  <h3 class="p1_text bold"> $'+(cart.items[i].original_line_price/100).toFixed(2)+' </h3>'+listing+' </div> <a class="remove_cart_drawer" data-line="'+cart.items[i].variant_id+'" href="javascript:;" class="cart-notification-remove p2_text" data-id="'+cart.items[i].variant_id+'">  remove </a> </div> </div> </div>');
//                    }
//                    else{
//                      $('.cart-notification-custom  #cart-notification-product').append('<div id="cart-notification-products '+cart.items[i].id+'" data-prod-name="prod-'+cart.items[i].handle+'" class="cart-notification-product"> <img class="cart-notification-product__image" src="'+prod_image+'" width="70" loading="lazy" > <div class="cart-notification-product__info"> <h3 class="cart-notification-product__name h4 p1_text bold" data-url="'+cart.items[i].url+'">'+cart.items[i].product_title +'</h3> '+obj+' <div class="cart_bottom_holder"><div class="qty_heading_holder"> <h3 class="p1_text bold"> $'+(cart.items[i].original_line_price/100).toFixed(2)+' </h3>'+listing+' </div> <a class="remove_cart_drawer" data-line="'+cart.items[i].variant_id+'" href="javascript:;" class="cart-notification-remove p2_text" data-id="'+cart.items[i].variant_id+'">  remove </a> </div> </div> </div>');
//                    }
//                  }
//                 $(".cart-notification-custom  .cart-notification-product[data-prod-name='prod-e5']").parent().prepend($(".cart-notification-custom  .cart-notification-product[data-prod-name='prod-e5']"))
//                    $("div#cart-notification-product").css("flex-direction","column");
//                   $(".cart-notification-custom #cart-notification__links").html("VIEW CART")
//                   $(".cart-notification-custom #cart-notification-button").html("VIEW CART")
//                   if(cart.items.length == 0){
//                     $(".cart-notification-custom .cart-notification__header .cart-notification__heading").css("display","none")
//                     $(".cart-notification-custom .cart-notification__header .cart-notification__heading.empty_cart_head").css("display","block")
//                     $(".cart-notification-custom").addClass("empty_cart_custom");
//                     $(".header .cart-count-bubble").css("display" ,"none");
//                   }
//                   else{
//                     $(".cart-notification-custom .cart-notification__header .cart-notification__heading").css("display","flex")
//                     $(".cart-notification-custom .cart-notification__header .cart-notification__heading.empty_cart_head").css("display","none")
//                     $(".cart-notification-custom").removeClass("empty_cart_custom");
//                      $(".header .cart-count-bubble").css("display" ,"block");
//                   }
//                 $(".cart_subtotal_holder span.subtotal_price").html('$'+(cart.original_total_price/100).toFixed(2)+'');
//               } 

//        });
//     }
  
//     cartDrawer2();
//     $(".custom_cart_icon").on("click",function(){
//       if($("#cart-notification").hasClass("active")){
//         $("#cart-notification").removeClass("active")
//         $("body").removeClass("cart_drawer_open");
//       }
      
//       else{
//         if(window.location.pathname == "/cart"){
//           window.location.reload();
//         }
//         else{
//         $("#cart-notification").addClass("active");
//           $("body").addClass("cart_drawer_open");
//         }
//       }

//     });
//     $(' .cart-notification-custom .cart-notification__close .icon-close').on('click',function(){
//         $('body').removeClass('cart_drawer_open');
//       $("#cart-notification").removeClass("active");
//     });
  
//     $(".template-product .product-form__submit").on("click",function(event){
//       $(".cart-notification-custom").removeClass("empty_cart_custom");
//       $(".cart-notification-custom .cart-notification__header .cart-notification__heading").css("display","flex");
//       $(".cart-notification-custom .cart-notification__header .cart-notification__heading.empty_cart_head").css("display","none");
//       console.log("casr")
//       event.preventDefault();
//       var qty = 1;
//       if($(".product quantity-input.quantity").length > 0){
//       	qty = $(".product quantity-input.quantity .quantity__input").val();
//       }
//       $.ajax({
//         type:"POST",
//         url:"/cart/add.js",
//         data:{id:$(this).closest("form").find("input[name='id']").val(),quantity:qty},
//         dataType:"json",
//         async:false,
//         success:function(cart){
//           console.log(cart)
// //           $(".template-product .product-form__submit span").html('<svg width="24" class="icon" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M22 11.0799V11.9999C21.9988 14.1563 21.3005 16.2545 20.0093 17.9817C18.7182 19.7088 16.9033 20.9723 14.8354 21.5838C12.7674 22.1952 10.5573 22.1218 8.53447 21.3744C6.51168 20.6271 4.78465 19.246 3.61096 17.4369C2.43727 15.6279 1.87979 13.4879 2.02168 11.3362C2.16356 9.18443 2.99721 7.13619 4.39828 5.49694C5.79935 3.85768 7.69279 2.71525 9.79619 2.24001C11.8996 1.76477 14.1003 1.9822 16.07 2.85986" stroke="#FAFAFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> <path d="M22 4L12 14.01L9 11.01" stroke="#FAFAFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> </svg> ADDED');
// //           $(".template-product .sticky_add_cart a span").html('<svg width="24" class="icon" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M22 11.0799V11.9999C21.9988 14.1563 21.3005 16.2545 20.0093 17.9817C18.7182 19.7088 16.9033 20.9723 14.8354 21.5838C12.7674 22.1952 10.5573 22.1218 8.53447 21.3744C6.51168 20.6271 4.78465 19.246 3.61096 17.4369C2.43727 15.6279 1.87979 13.4879 2.02168 11.3362C2.16356 9.18443 2.99721 7.13619 4.39828 5.49694C5.79935 3.85768 7.69279 2.71525 9.79619 2.24001C11.8996 1.76477 14.1003 1.9822 16.07 2.85986" stroke="#FAFAFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> <path d="M22 4L12 14.01L9 11.01" stroke="#FAFAFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> </svg> ADDED ');
// //           $(".template-product .product-form__submit").css("pointer-events","none");
// //           $(".template-product .sticky_add_cart").css("pointer-events","none");
// //           setTimeout(function(){ 
// //             $(".template-product .product-form__submit span").html("ADD TO CART");
// //             $(".template-product .sticky_add_cart a span").html("ADD TO CART ");
// //             $(".template-product .product-form__submit").css("pointer-events","all");
// //             $(".template-product .sticky_add_cart").css("pointer-events","all");
// //           }, 3000);
//             cartDrawer();
//         }
//       });

//     });
  
//     $(document).on("click",".cart_bottom_holder .cart_quantity .adjust_qty",function(){
//       var qty = $(this).parent('.qty_box').find('input').val();
//       if($(this).hasClass('minus')){
//         if(qty > 0){
//           qty = parseInt(qty) - 1; 
//         }
//       }else{
//         qty = parseInt(qty) + 1;
//       }
//       var line = $(this).parent('.qty_box').find('input').data('line') ;
//        var data = {id:line,quantity:qty}
//        $.post('/cart/change.js',data,function(change){
//         cartDrawer();
//       },'json');
//     });
//     $(document).on("click",".cart_bottom_holder .remove_cart_drawer ",function(){
//       var qty = 0;
//       var line = $(this).attr("data-line")
//        var data = {id:line,quantity:qty}
//        $.post('/cart/change.js',data,function(change){
//         cartDrawer();
//       },'json');
//     });
  
  
       //TOGGLING NESTED ul
  $(document).on("click",".drop-down .selected a",function() {
         $(this).closest(".drop-down").find(".options ul").toggle();
    });

    //SELECT OPTIONS AND HIDE OPTION AFTER SELECTION
    $(document).on("click",".drop-down .options ul li a",function() {
        var text = $(this).html();
        $(this).closest(".drop-down").find(".selected a span").html(text);
         $(this).closest(".drop-down").find(".options ul").hide();
    }); 

  $(document).on("click",".product quantity-dropdown.drop-down .options ul li a",function() {
  	$(".product quantity-input.quantity .quantity__input").val($(this).attr("data-value"));
  });
  
  $(document).on("click",".cart-items quantity-dropdown.drop-down .options ul li a",function() {
        var qty = $(this).attr("data-value");
    var line = $(this).closest(".drop-down").attr("data-line")
         var data = {line:line,quantity:qty}
//          $.post('/cart/change.js',data,function(change){
//           window.location.reload();
//         },'json');
         var cart_items  = new CartItems();
        cart_items.updateQuantity(line,qty);
        setTimeout(function(){ 
           $.ajax({
            type: 'GET',
            url: '/cart.js',
            dataType: 'json', 
            success: function (cart) {
              console.log(cart.item_count);
//               $(".cart-top-wrapper .title-wrapper-with-link .p1_text").html(cart.item_count+" items")
//                 $(".cart-item[data-prod-name='prod-e5']").parent().prepend($(".cart-item[data-prod-name='prod-e5']"))
                 cartDrawer2()
            }
          });
        }, 1000);      
    }); 
  

    //HIDE OPTIONS IF CLICKED ANYWHERE ELSE ON PAGE
    $(document).bind('click', function(e) {
        var $clicked = $(e.target);
        if (! $clicked.parents().hasClass("drop-down"))
            $(".drop-down .options ul").hide();
    });
  
    $(".product-color--swatches input").on("change", function(){
      $(this).closest(".product-color--swatches").find(".selected__color").html($(this).val());
    });
  
//   $(".inner--menu-container.list-menu--disclosure").on('mouseleave', function() {
    
//   });
  
  
  
   $(document).on("click"," quantity-dropdown.drop-down.cart_quantity_new .options ul li a",function() {
        var qty = $(this).attr("data-value");
        var line = $(this).closest(".drop-down").attr("data-line")
         var data = {line:line,quantity:qty}
           $.post('/cart/change.js',data,function(change){
            cartDrawer();
          },'json');
       
        
    }); 
  
  $(document).on("click", ".cart-notification-product__name", function(){
  	window.location = $(this).attr("data-url");
  });
  
  
      $("#FacetFiltersForm .facets__summary").on("click", function(){
          if($(this).hasClass("activated")){
            $(this).removeClass("activated");
            $(this).next().slideUp();
          }
          else{
            $("#FacetFiltersForm .facets__summary").removeClass("activated");
            $("#FacetFiltersForm .filter_list_holder").slideUp();
           $(this).addClass("activated");
            $(this).next().slideDown();
          }
      })
      
      
      
//     CART DRAWER WITH QUANTITY BUTTON  
      
//       function cartDrawer(){
//       $.ajax({
//               type: 'GET',
//               url: '/cart.js',
//               dataType: 'json', 
//               success: function (cart) {
//                  for(var i =0; i < cart.items.length; i++){
//                    var obj = "";
//                    console.log(cart.items[i].handle)
//                    if(cart.items[i].variant_options[0] != "Default Title"){
//                      obj += "<dl>";
//                      for(j = 0; j < cart.items[i].options_with_values.length; j++){
//                           obj +=   '<div class="cart-notification-product__option h4"> <dt>'+cart.items[i].options_with_values[j].name+': </dt> <dd>'+cart.items[i].options_with_values[j].value+'</dd> </div>'
//                      }
//                     obj += "</dl>";
//                    }
//                    var prod_image = cart.items[i].image.replace(".jpg","_140x.jpg")
//                    prod_image = prod_image.replace(".png","_140x.png")
//                    if(i == 0 ){
//   //                  	$('.cart-notification-custom  #cart-notification-product').html('<div id="cart-notification-products '+cart.items[i].id+'" class="cart-notification-product"> <img class="cart-notification-product__image" src="'+cart.items[i].image+'" width="70" loading="lazy" > <div class="cart-notification-product__info"> <h3 class="cart-notification-product__name h4 p1_text bold">'+cart.items[i].product_title +'</h3> <dl> <div class="cart-notification-product__option h4 p1_text"> '+cart.items[i].product_type+' </div> </dl> <div class="cart_bottom_holder"> <h3 class="p1_text bold"> $'+cart.items[i].original_line_price/100+' </h3><div class="cart_quantity p2_text ">Quantity: '+cart.items[i].quantity+' </div> <a href="/cart/change?id='+cart.items[i].variant_id+'&quantity=0" class="cart-notification-remove p2_text" data-id="'+cart.items[i].variant_id+'">  remove </a> </div> </div> </div>');
//                      $('.cart-notification-custom  #cart-notification-product').html('<div id="cart-notification-products '+cart.items[i].id+'" data-prod-name="prod-'+cart.items[i].handle+'" class="cart-notification-product"> <img class="cart-notification-product__image" src="'+prod_image+'" width="70" loading="lazy" > <div class="cart-notification-product__info"> <h3 class="cart-notification-product__name h4 p1_text bold" data-url="'+cart.items[i].url+'">'+cart.items[i].product_title +'</h3> '+obj+' <div class="cart_bottom_holder"> <div class="qty_heading_holder">  <h3 class="p1_text bold"> $'+(cart.items[i].original_line_price/100).toFixed(2)+' </h3><div class="cart_quantity qty_box p2_text"><span class="adjust_qty minus"> <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M3.75 9H14.25" stroke="#222626" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> </svg> </span> <input class="input_quantity" type="text" data-line="'+cart.items[i].variant_id+'" readonly value="'+cart.items[i].quantity+'" > <span class="adjust_qty plus"> <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M9 3.75V14.25" stroke="#222626" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> <path d="M3.75 9H14.25" stroke="#222626" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> </svg> </span>  </div> </div> <a class="remove_cart_drawer" data-line="'+cart.items[i].variant_id+'" href="javascript:;" class="cart-notification-remove p2_text" data-id="'+cart.items[i].variant_id+'">  remove </a> </div> </div> </div>');
//                    }
//                    else{
//   //                  $('.cart-notification-custom  #cart-notification-product').append('<div id="cart-notification-products '+cart.items[i].id+'" class="cart-notification-product"> <img class="cart-notification-product__image" src="'+cart.items[i].image+'" width="70" loading="lazy" > <div class="cart-notification-product__info"> <h3 class="cart-notification-product__name h4 p1_text bold">'+cart.items[i].product_title +'</h3> <dl> <div class="cart-notification-product__option h4 p1_text"> '+cart.items[i].product_type+' </div> </dl> <div class="cart_bottom_holder"> <h3 class="p1_text bold"> $'+cart.items[i].original_line_price/100+' </h3><div class="cart_quantity p2_text ">Quantity: '+cart.items[i].quantity+' </div> <a href="/cart/change?id='+cart.items[i].variant_id+'&quantity=0" class="cart-notification-remove p2_text" data-id="'+cart.items[i].variant_id+'">  remove </a> </div> </div> </div>');
//                      $('.cart-notification-custom  #cart-notification-product').append('<div id="cart-notification-products '+cart.items[i].id+'" data-prod-name="prod-'+cart.items[i].handle+'" class="cart-notification-product"> <img class="cart-notification-product__image" src="'+prod_image+'" width="70" loading="lazy" > <div class="cart-notification-product__info"> <h3 class="cart-notification-product__name h4 p1_text bold" data-url="'+cart.items[i].url+'">'+cart.items[i].product_title +'</h3> '+obj+' <div class="cart_bottom_holder"><div class="qty_heading_holder"> <h3 class="p1_text bold"> $'+(cart.items[i].original_line_price/100).toFixed(2)+' </h3><div class="cart_quantity qty_box p2_text"><span class="adjust_qty minus"> <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M3.75 9H14.25" stroke="#222626" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> </svg> </span> <input class="input_quantity" type="text" data-line="'+cart.items[i].variant_id+'" readonly value="'+cart.items[i].quantity+'" > <span class="adjust_qty plus"> <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M9 3.75V14.25" stroke="#222626" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> <path d="M3.75 9H14.25" stroke="#222626" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> </svg> </span>  </div> </div> <a class="remove_cart_drawer" data-line="'+cart.items[i].variant_id+'" href="javascript:;" class="cart-notification-remove p2_text" data-id="'+cart.items[i].variant_id+'">  remove </a> </div> </div> </div>');
//                    }
//                  }
//                 $(".cart-notification-custom  .cart-notification-product[data-prod-name='prod-e5']").parent().prepend($(".cart-notification-custom  .cart-notification-product[data-prod-name='prod-e5']"))
//                     $("div#cart-notification-product").css("flex-direction","column");
//                     $(".cart-notification-custom #cart-notification__links").html("VIEW CART")
//                     $(".cart-notification-custom #cart-notification-button").html("VIEW CART")
//                     $(".header__icons  .cart-count-bubble span").html(cart.item_count)
//                     if(cart.items.length == 0){
//                       $(".cart-notification-custom .cart-notification__header .cart-notification__heading").css("display","none")
//                       $(".cart-notification-custom .cart-notification__header .cart-notification__heading.empty_cart_head").css("display","block")
//                       $("#cart-notification-product").html("");
//                       $(".cart-notification-custom").addClass("empty_cart_custom");
//                        $(".header .cart-count-bubble").css("display" ,"none");
//                     }
//                     else{
//                       $(".cart-notification-custom .cart-notification__header .cart-notification__heading").css("display","flex")
//                       $(".cart-notification-custom .cart-notification__header .cart-notification__heading.empty_cart_head").css("display","none")
//                       $(".cart-notification-custom").removeClass("empty_cart_custom");
//                        $(".header .cart-count-bubble").css("display" ,"block");
//                     }
//                     $(".cart_subtotal_holder span.subtotal_price").html('$'+(cart.original_total_price/100).toFixed(2)+'');
//                     $("#cart-notification").addClass("active");
//                    $("body").addClass("cart_drawer_open");
//               } 

//        });
//     }
//     function cartDrawer2(){
//       $.ajax({
//               type: 'GET',
//               url: '/cart.js',
//               dataType: 'json', 
//               success: function (cart) {
//                  for(var i =0; i < cart.items.length; i++){
//                    var obj = "";
//                     console.log(cart.items[i].url)
//                    if(cart.items[i].variant_options[0] != "Default Title"){
//                      obj += "<dl>";
//                      for(j = 0; j < cart.items[i].options_with_values.length; j++){
//                           obj +=   '<div class="cart-notification-product__option h4"> <dt>'+cart.items[i].options_with_values[j].name+': </dt> <dd>'+cart.items[i].options_with_values[j].value+'</dd> </div>'
//                      }
//                     obj += "</dl>";
//                    }
//                    var prod_image = cart.items[i].image.replace(".jpg","_140x.jpg")
//                    prod_image = prod_image.replace(".png","_140x.png")
//                   if(i == 0 ){
//   //                  	$('.cart-notification-custom  #cart-notification-product').html('<div id="cart-notification-products '+cart.items[i].id+'" class="cart-notification-product"> <img class="cart-notification-product__image" src="'+cart.items[i].image+'" width="70" loading="lazy" > <div class="cart-notification-product__info"> <h3 class="cart-notification-product__name h4 p1_text bold">'+cart.items[i].product_title +'</h3> <dl> <div class="cart-notification-product__option h4 p1_text"> '+cart.items[i].product_type+' </div> </dl> <div class="cart_bottom_holder"> <h3 class="p1_text bold"> $'+cart.items[i].original_line_price/100+' </h3><div class="cart_quantity p2_text ">Quantity: '+cart.items[i].quantity+' </div> <a href="/cart/change?id='+cart.items[i].variant_id+'&quantity=0" class="cart-notification-remove p2_text" data-id="'+cart.items[i].variant_id+'">  remove </a> </div> </div> </div>');
//                      $('.cart-notification-custom  #cart-notification-product').html('<div id="cart-notification-products '+cart.items[i].id+'" data-prod-name="prod-'+cart.items[i].handle+'" class="cart-notification-product"> <img class="cart-notification-product__image" src="'+prod_image+'" width="70" loading="lazy" > <div class="cart-notification-product__info"> <h3 class="cart-notification-product__name h4 p1_text bold" data-url="'+cart.items[i].url+'">'+cart.items[i].product_title +'</h3> '+obj+' <div class="cart_bottom_holder"> <div class="qty_heading_holder">  <h3 class="p1_text bold"> $'+(cart.items[i].original_line_price/100).toFixed(2)+' </h3><div class="cart_quantity qty_box p2_text"><span class="adjust_qty minus"> <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M3.75 9H14.25" stroke="#222626" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> </svg> </span> <input class="input_quantity" type="text" data-line="'+cart.items[i].variant_id+'" readonly value="'+cart.items[i].quantity+'" > <span class="adjust_qty plus"> <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M9 3.75V14.25" stroke="#222626" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> <path d="M3.75 9H14.25" stroke="#222626" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> </svg> </span>  </div> </div> <a class="remove_cart_drawer" data-line="'+cart.items[i].variant_id+'" href="javascript:;" class="cart-notification-remove p2_text" data-id="'+cart.items[i].variant_id+'">  remove </a> </div> </div> </div>');
//                    }
//                    else{
//   //                  $('.cart-notification-custom  #cart-notification-product').append('<div id="cart-notification-products '+cart.items[i].id+'" class="cart-notification-product"> <img class="cart-notification-product__image" src="'+cart.items[i].image+'" width="70" loading="lazy" > <div class="cart-notification-product__info"> <h3 class="cart-notification-product__name h4 p1_text bold">'+cart.items[i].product_title +'</h3> <dl> <div class="cart-notification-product__option h4 p1_text"> '+cart.items[i].product_type+' </div> </dl> <div class="cart_bottom_holder"> <h3 class="p1_text bold"> $'+cart.items[i].original_line_price/100+' </h3><div class="cart_quantity p2_text ">Quantity: '+cart.items[i].quantity+' </div> <a href="/cart/change?id='+cart.items[i].variant_id+'&quantity=0" class="cart-notification-remove p2_text" data-id="'+cart.items[i].variant_id+'">  remove </a> </div> </div> </div>');
//                      $('.cart-notification-custom  #cart-notification-product').append('<div id="cart-notification-products '+cart.items[i].id+'" data-prod-name="prod-'+cart.items[i].handle+'" class="cart-notification-product"> <img class="cart-notification-product__image" src="'+prod_image+'" width="70" loading="lazy" > <div class="cart-notification-product__info"> <h3 class="cart-notification-product__name h4 p1_text bold" data-url="'+cart.items[i].url+'">'+cart.items[i].product_title +'</h3> '+obj+' <div class="cart_bottom_holder"><div class="qty_heading_holder"> <h3 class="p1_text bold"> $'+(cart.items[i].original_line_price/100).toFixed(2)+' </h3><div class="cart_quantity qty_box p2_text"><span class="adjust_qty minus"> <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M3.75 9H14.25" stroke="#222626" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> </svg> </span> <input class="input_quantity" type="text" data-line="'+cart.items[i].variant_id+'" readonly value="'+cart.items[i].quantity+'" > <span class="adjust_qty plus"> <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M9 3.75V14.25" stroke="#222626" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> <path d="M3.75 9H14.25" stroke="#222626" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> </svg> </span>  </div> </div> <a class="remove_cart_drawer" data-line="'+cart.items[i].variant_id+'" href="javascript:;" class="cart-notification-remove p2_text" data-id="'+cart.items[i].variant_id+'">  remove </a> </div> </div> </div>');
//                    }
//                  }
//                 $(".cart-notification-custom  .cart-notification-product[data-prod-name='prod-e5']").parent().prepend($(".cart-notification-custom  .cart-notification-product[data-prod-name='prod-e5']"))
//                    $("div#cart-notification-product").css("flex-direction","column");
//                   $(".cart-notification-custom #cart-notification__links").html("VIEW CART")
//                   $(".cart-notification-custom #cart-notification-button").html("VIEW CART")
//                   if(cart.items.length == 0){
//                     $(".cart-notification-custom .cart-notification__header .cart-notification__heading").css("display","none")
//                     $(".cart-notification-custom .cart-notification__header .cart-notification__heading.empty_cart_head").css("display","block")
//                     $(".cart-notification-custom").addClass("empty_cart_custom");
//                     $(".header .cart-count-bubble").css("display" ,"none");
//                   }
//                   else{
//                     $(".cart-notification-custom .cart-notification__header .cart-notification__heading").css("display","flex")
//                     $(".cart-notification-custom .cart-notification__header .cart-notification__heading.empty_cart_head").css("display","none")
//                     $(".cart-notification-custom").removeClass("empty_cart_custom");
//                      $(".header .cart-count-bubble").css("display" ,"block");
//                   }
//                 $(".cart_subtotal_holder span.subtotal_price").html('$'+(cart.original_total_price/100).toFixed(2)+'');
//               } 

//        });
//     }
  
})